function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelmodal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166.345,
    height: 120,
    viewBox: "0 0 166.345 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "56pk1lbepa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 664",
    transform: "translate(0 -.315)",
    style: {
      stroke: "#707070",
      fill: "#fff"
    },
    d: "M0 0h166.345v120H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17",
    transform: "translate(0 .315)",
    style: {
      clipPath: "url(#56pk1lbepa)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6055"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5785",
    transform: "translate(28 36.711)",
    style: {
      fill: "#ffc727"
    },
    d: "M0 0h91.571v70.969H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5786",
    transform: "translate(28 36.711)",
    style: {
      opacity: 0.2
    },
    d: "M0 0h91.571v70.969H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5787",
    transform: "rotate(180 31.341 53.843)",
    style: {
      opacity: 0.2
    },
    d: "M0 0h34.682v70.969H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41018",
    d: "M298.39 398.4q3.859-7.57 7.638-15.189l7.52-15.263 7.433-15.331q3.717-7.675 7.316-15.412-3.847 7.569-7.631 15.189l-7.526 15.269L305.706 383q-3.699 7.642-7.316 15.4z",
    transform: "translate(-267.999 -295.581)",
    style: {
      fill: "#ffc727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41019",
    d: "M298.39 337.16q3.624 7.731 7.316 15.412l7.433 15.331 7.526 15.263q3.772 7.619 7.631 15.189-3.618-7.731-7.316-15.405l-7.433-15.331-7.52-15.269q-3.784-7.62-7.637-15.19z",
    transform: "translate(-267.999 -295.561)",
    style: {
      fill: "#ffc727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5788",
    transform: "translate(40.005 36.711)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h10.53v8.66H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5789",
    transform: "translate(99.594 92.553)",
    style: {
      fill: "#263238"
    },
    d: "M0 0h.737v10.407H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5790",
    transform: "translate(101.36 92.553)",
    style: {
      fill: "#263238"
    },
    d: "M0 0h.737v10.407H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5791",
    transform: "translate(103.131 92.553)",
    style: {
      fill: "#263238"
    },
    d: "M0 0h.737v10.407H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5792",
    transform: "translate(104.903 92.553)",
    style: {
      fill: "#263238"
    },
    d: "M0 0h.737v10.407H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5793",
    transform: "translate(106.674 92.553)",
    style: {
      fill: "#263238"
    },
    d: "M0 0h.737v10.407H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5794",
    transform: "translate(108.446 92.553)",
    style: {
      fill: "#263238"
    },
    d: "M0 0h.737v10.407H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5795",
    transform: "translate(110.211 92.553)",
    style: {
      fill: "#263238"
    },
    d: "M0 0h.737v10.407H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5796",
    transform: "translate(111.983 92.553)",
    style: {
      fill: "#263238"
    },
    d: "M0 0h.737v10.407H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5797",
    transform: "translate(113.755 92.553)",
    style: {
      fill: "#263238"
    },
    d: "M0 0h.737v10.407H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41020",
    d: "m396.072 429.037 2.837.787h-6.659l2.837-.793V425.2c-2.032-.266-2.837-2.267-2.837-5.773h6.659c0 3.494-.805 5.507-2.837 5.773z",
    transform: "translate(-303.719 -326.871)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41021",
    d: "M384.861 424.732h-1.741v5.092h-4.454v-5.092h-1.746l3.977-5.3z",
    transform: "translate(-297.885 -326.871)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41022",
    d: "M407.409 435.114v-4.98l-56.889-9.224v14.2z",
    transform: "translate(-287.838 -327.434)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5798",
    transform: "translate(45.524 11.686)",
    style: {
      fill: "#ffc727"
    },
    d: "M0 0h70.746v25.025H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5799",
    transform: "translate(45.524 11.686)",
    style: {
      opacity: 0.2
    },
    d: "M0 0h70.746v25.025H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5800",
    transform: "rotate(180 33.574 18.355)",
    style: {
      opacity: 0.2
    },
    d: "M0 0h21.618v25.025H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41023",
    d: "M325.23 313.231c1.6-1.784 3.19-3.568 4.757-5.358l4.689-5.383 4.633-5.408q2.3-2.707 4.559-5.432-2.4 2.67-4.757 5.358l-4.7 5.389-4.627 5.408q-2.299 2.695-4.554 5.426z",
    transform: "translate(-278.213 -278.242)",
    style: {
      fill: "#ffc727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41024",
    d: "M325.23 291.65q2.255 2.719 4.559 5.432l4.627 5.408 4.7 5.383q2.354 2.688 4.757 5.358-2.261-2.732-4.559-5.432l-4.633-5.4-4.689-5.383a467.441 467.441 0 0 0-4.762-5.366z",
    transform: "translate(-278.213 -278.242)",
    style: {
      fill: "#ffc727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5801",
    transform: "translate(53.007 11.686)",
    style: {
      fill: "#ebebeb"
    },
    d: "M0 0h6.566v5.86H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5802",
    transform: "translate(103.819 27.283)",
    style: {
      fill: "#263238"
    },
    d: "M0 0h.458v6.485H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5803",
    transform: "translate(104.921 27.283)",
    style: {
      fill: "#263238"
    },
    d: "M0 0h.458v6.485H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5804",
    transform: "translate(106.024 27.283)",
    style: {
      fill: "#263238"
    },
    d: "M0 0h.458v6.485H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5805",
    transform: "translate(107.127 27.283)",
    style: {
      fill: "#263238"
    },
    d: "M0 0h.458v6.485H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5806",
    transform: "translate(108.229 27.283)",
    style: {
      fill: "#263238"
    },
    d: "M0 0h.458v6.485H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5807",
    transform: "translate(109.332 27.283)",
    style: {
      fill: "#263238"
    },
    d: "M0 0h.458v6.485H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5808",
    transform: "translate(110.441 27.283)",
    style: {
      fill: "#263238"
    },
    d: "M0 0h.458v6.485H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5809",
    transform: "translate(111.543 27.283)",
    style: {
      fill: "#263238"
    },
    d: "M0 0h.458v6.485H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5810",
    transform: "translate(112.646 27.283)",
    style: {
      fill: "#263238"
    },
    d: "M0 0h.458v6.485H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41025",
    d: "m408.175 320.04 1.772.5h-4.157l1.772-.5v-2.385c-1.239-.161-1.772-1.412-1.772-3.6h4.156c0 2.18-.5 3.438-1.772 3.6z",
    transform: "translate(-308.872 -286.767)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41026",
    d: "M401.189 317.358h-1.084v3.178h-2.775v-3.178h-1.09l2.478-3.308z",
    transform: "translate(-305.237 -286.767)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41027",
    d: "M406.847 323.832v-3.1l-49.127-5.752v8.852z",
    transform: "translate(-290.578 -287.121)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 376",
    transform: "translate(84.635 19.262)",
    style: {
      strokeWidth: 4,
      stroke: "#c9c9c9",
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.636,
    cy: 26.636,
    r: 26.636,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.636,
    cy: 26.636,
    r: 24.636,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "x (2)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 11",
    transform: "translate(103.837 38.464)",
    style: {
      stroke: "#0a243f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none",
      strokeWidth: 4
    },
    d: "M14.866 0 0 14.866"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 12",
    transform: "translate(103.837 38.464)",
    style: {
      stroke: "#0a243f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none",
      strokeWidth: 4
    },
    d: "m0 0 14.866 14.866"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelmodal);
export default __webpack_public_path__ + "static/media/cancelmodal.4a6e3b5fc1335406a1631a80c328750c.svg";
export { ForwardRef as ReactComponent };